import axios from "axios";

import modalContentMock from "../tests/mocks/modalContentMock";
import { TGetLiferayModalContentResponse } from "./types";
import { mockGetTierResponse } from "../tests/mocks/mockGetTier";

const getTiers = async (apiDomain: string) => {
  const smilesGetTierUrl = `${apiDomain}/members/v1/members/tier`;
  const JWTToken = localStorage.getItem("session-token");

  const vbzDebug = localStorage.getItem("vbzDebug");

  if (vbzDebug === "true") {
    return mockGetTierResponse;
  }

  return axios
    .get(smilesGetTierUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => error.response.data.data.error_code);
};

const getModalContent = async (liferayDomain: string, siteId: string) => {
  const vbzDebug = localStorage.getItem("vbzDebug");

  const url = `${liferayDomain}/o/headless-delivery/v1.0/sites/${siteId}/structured-contents?flatten=true&filter=friendlyUrlPath eq 'mmc_modal_news'`;

  if (vbzDebug === "true") {
    return modalContentMock.items[0].contentFields[0].contentFieldValue.data;
  }

  return axios.get<TGetLiferayModalContentResponse>(url).then((res) => {
    return res.data.items[0].contentFields[0].contentFieldValue.data;
  });
};

export { getTiers, getModalContent };
